import type { FC } from "react";

import { Badge } from "../../../../components/Badge/Badge";
import { FilterIcon, ShieldAttachIcon } from "../../../../components/icons";

const Badges: FC = () => {
  return (
    <div className="d-grid grid-stats-section">
      <div className="row gy-5 g-xl-5 row-plex widget-container">
        <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-xl-0">
          <Badge
            variant="info"
            content={{
              value: "123",
              title: "Blocked prompts",
              tooltipText:
                "The number of prompts that were blocked by the system.",
              rightItems: [
                {
                  icon: <ShieldAttachIcon size={16} />,
                  text: "78",
                  subtitle: "cyber attacks",
                },
                {
                  icon: <FilterIcon size={16} />,
                  text: "78",
                  subtitle: "content filter",
                },
              ],
            }}
          />
        </div>
        <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-xl-0">
          <Badge
            variant="success"
            content={{
              value: "5.2%",
              title: "Percentage of blocked prompts",
            }}
          />
        </div>

        {/* <div className="col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-xl-0">
        <Badge
          className="bg-danger"
          countText="20"
          text="Users with blocked prompts"
        />
      </div> */}
      </div>
    </div>
  );
};

export { Badges };
